const SvgDelay = (props) => (
  <svg height="1em" viewBox="0 0 16 17" width="1em" {...props}>
    <g fill="none" fillRule="nonzero" transform="translate(-1)">
      <path d="M0 0h18v18H0z" />
      <circle cx={9} cy={9} r={7} stroke="currentColor" />
      <path d="M7 0h4v2H7z" fill="currentColor" />
      <path d="M14 4l1-1" stroke="currentColor" strokeLinecap="square" />
      <path
        d="M9 9V5"
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth={1.5}
      />
    </g>
  </svg>
)

export default SvgDelay
